import React, { useState } from 'react'
import styled from 'styled-components'
import { PlayCircle } from 'react-feather'

export interface INFTPlayAudio {
  src: string
}

const PlaySoundButton = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  svg {
    margin-right: 5px;
  }
`

export default function NFTPlayAudio({ src }: INFTPlayAudio) {
  const [audio] = useState<HTMLAudioElement>(new Audio(src))
  return (
    <PlaySoundButton onClick={() => audio.play()}>
      <PlayCircle width="1rem" /> Play Sound
    </PlaySoundButton>
  )
}
